import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  MenuItem,
} from "@mui/material";
import rtmData from "../../data/rtmHistoricalStationData.json";
import ttStopData from "../../data/ttHistoricalStopData.json";
import ttLineData from "../../data/ttHistoricalLineData.json";
import { StyledInputLabel, StyledSelect } from "../FormElements/CustomSelect";
import { useEffect, useState } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Slider from "@mui/material/Slider";
import dayjs from "dayjs";

function HistoricalDashboardForTTAndRTM({ organisation }) {
  const [rtmStation, setRtmStation] = useState("");
  const [diagram, setDiagram] = useState(null);
  const [diagramToShow, setDiagramToShow] = useState(null);
  const [values, setValues] = useState({
    date: "",
    scale: 6,
    dateSelection: false,
  });
  const description =
    organisation === "TT"
      ? "Choose the desired line or stop id from the options below to get the corresponding graph."
      : "Choose the desired station id from the options below to get the corresponding graph.";

  const urls = {
    rtm: "https://grafana.sunrise.staging.squaredev.io/d-solo/e4052c56-3072-49c1-a328-fe2a529b4eca/transport-crtm-historical-station?orgId=1&from=&to=&var-station_id=",
    ttLine:
      "https://grafana.sunrise.staging.squaredev.io/d-solo/a161400d-d56f-4562-a591-77fc4807851d/transport-tt-historical-line?orgId=1&from=&to=&var-line_id=",
    ttStop:
      "https://grafana.sunrise.staging.squaredev.io/d-solo/d6e8dc9a-1f88-4d2d-b407-e5534ef914f7/transport-tt-historical-stop?&orgId=1&from=&to=&var-stop_id=",
  };

  let datePickerStartDate = new Date("2017-01-01");
  let datePickerEndDate = new Date("2024-09-24");

  const sliderValues = {
    min: 0,
    max: 12,
  };

  const dateSelectionhandler = () => {
    setValues((prevValues) => ({
      ...prevValues,
      dateSelection: !prevValues.dateSelection,
    }));
  };

  const onDateChange = (event) => {
    let a = event.$y + "/";
    let b = event.$M + 1;
    let c = "/" + event.$D;
    setValues((prevValues) => ({
      ...prevValues,
      date: a + b + c,
    }));
  };

  const onChangeScale = (event) => {
    setValues((prevValues) => ({
      ...prevValues,
      scale: event.target.value,
    }));
  };

  useEffect(() => {
    function calculateEndDate(dateToUpdate, startDate) {
      return dateToUpdate.setMonth(startDate.getMonth() + values.scale);
    }
    if (values.dateSelection) {
      if (diagram === null) {
        setDiagramToShow(null);
      } else {
        if (values.date !== "") {
          let startDate = new Date(values.date);
          let tempDate = new Date(startDate);
          let toDate = calculateEndDate(tempDate, startDate);
          let url = new URL(diagram);
          url.searchParams.set("from", startDate.getTime());
          url.searchParams.set("to", new Date(toDate).getTime());
          setDiagramToShow(url.href);
        } else {
          setDiagramToShow(diagram);
        }
      }
    } else {
      setDiagramToShow(diagram);
    }
  }, [diagram, values]);

  return (
    <div>
      <div className="flexBox">
        <Box sx={{ width: "100%" }}>
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          >
            <Grid item xs={12} md={12}>
              <div
                className="chartBox chartOptions flex-column"
                style={{ gap: "16px", alignItems: "flex-start" }}
              >
                <h2 className="grafanaTitle">Dashboard</h2>
                <p>
                  {description} You can optionally enable date selection to pick
                  a start date and define a range of up to 12 months after.
                </p>
                <div className="dashChart flexBox">
                  {organisation === "RTM" && (
                    <OptionsForRTM
                      setDiagram={setDiagram}
                      rtmStation={rtmStation}
                      setRtmStation={setRtmStation}
                      urls={urls}
                    />
                  )}
                  {organisation === "TT" && (
                    <OptionsForTT setDiagram={setDiagram} urls={urls} />
                  )}
                </div>
                <div className="dashChart">
                  <FormControl size="small" fullWidth={true}>
                    <div className="flexBox flexColumn">
                      <div className="grafanaType">
                        <FormControlLabel
                          control={
                            <Checkbox
                              onClick={dateSelectionhandler}
                              style={{ color: "#35afaf" }}
                              checked={values.dateSelection}
                            />
                          }
                          label="Enable date selection"
                        />
                        <div style={{ zIndex: "999" }}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              format="DD/MM/YYYY"
                              onChange={onDateChange}
                              minDate={dayjs(datePickerStartDate)}
                              maxDate={dayjs(datePickerEndDate)}
                              slotProps={{
                                textField: { required: true },
                              }}
                              disabled={!values.dateSelection}
                            />
                          </LocalizationProvider>
                        </div>
                        <div className="grafana-slider">
                          <span>{sliderValues.min}</span>
                          <Slider
                            size="medium"
                            defaultValue={values.scale}
                            aria-label="medium"
                            min={sliderValues.min}
                            max={sliderValues.max}
                            valueLabelDisplay="auto"
                            onChange={onChangeScale}
                            style={{
                              color: `${
                                !values.dateSelection ? "#4F4F4F" : "#35afaf"
                              }`,
                            }}
                            value={values.scale}
                            disabled={!values.dateSelection}
                          />
                          <span>{sliderValues.max}</span>
                        </div>
                        <FormControlLabel
                          control={
                            <Checkbox
                              style={{ color: "#35afaf" }}
                              checked={values.covid}
                            />
                          }
                          style={{ visibility: "hidden" }}
                          label="COVID"
                        />
                      </div>
                    </div>
                  </FormControl>
                </div>
              </div>
            </Grid>
            {diagramToShow && (
              <Grid item xs={12} md={12}>
                <div className="chartBox">
                  <div className="chartTitle">
                    <div
                      style={{
                        padding: "4px 10px",
                      }}
                    >
                      <p>
                        ✨ Tip: You can zoom in on the graph by selecting an
                        area with your mouse. To zoom out, simply press{" "}
                        <strong>Ctrl + Z</strong>.
                      </p>
                    </div>
                  </div>
                  <iframe
                    src={diagramToShow}
                    width="100%"
                    height="500"
                    title="Graph"
                  ></iframe>
                </div>
              </Grid>
            )}
          </Grid>
        </Box>
      </div>
    </div>
  );
}

function OptionsForRTM({ setDiagram, rtmStation, setRtmStation, urls }) {
  const handleRtmStationChange = (e) => {
    setRtmStation(e.target.value);
    if (e.target.value !== "") {
      setDiagram(urls.rtm + e.target.value + "&panelId=1");
    } else {
      setDiagram(null);
    }
  };
  return (
    <FormControl style={{ width: "350px", zIndex: 2 }}>
      <StyledInputLabel htmlFor="rtm-station-select">Station</StyledInputLabel>
      <StyledSelect
        labelId="rtm-station-select"
        label={"Station"}
        onChange={handleRtmStationChange}
        value={rtmStation}
      >
        <MenuItem value=""></MenuItem>
        {rtmData.map((item, index) => (
          <MenuItem key={`${item.station_id}-${index}`} value={item.station_id}>
            {item.station_name}
          </MenuItem>
        ))}
      </StyledSelect>
    </FormControl>
  );
}

function OptionsForTT({ setDiagram, urls }) {
  const [type, setType] = useState("");
  const [stop, setStop] = useState("");
  const [line, setLine] = useState("");

  const handleStopChange = (e) => {
    setLine("");
    setStop(e.target.value);

    if (e.target.value !== "") {
      setDiagram(urls.ttStop + e.target.value + "&panelId=1");
    } else {
      setDiagram(null);
    }
  };

  const handleLineChange = (e) => {
    setStop("");
    setLine(e.target.value);
    if (e.target.value !== "") {
      setDiagram(urls.ttLine + e.target.value + "&panelId=1");
    } else {
      setDiagram(null);
    }
  };

  useEffect(() => {
    setDiagram(null);
  }, [type, setDiagram]);
  return (
    <>
      <FormControl style={{ width: "350px", zIndex: 2 }}>
        <StyledInputLabel htmlFor="tt-type-select">Type</StyledInputLabel>
        <StyledSelect
          labelId="tt-type-select"
          label={"Type"}
          onChange={(e) => setType(e.target.value)}
          value={type}
        >
          <MenuItem value=""></MenuItem>
          <MenuItem value="lines">Lines</MenuItem>
          <MenuItem value="stops">Stops</MenuItem>
        </StyledSelect>
      </FormControl>
      {type === "lines" && (
        <FormControl style={{ width: "350px", zIndex: 2 }}>
          <StyledInputLabel htmlFor="tt-line">Line</StyledInputLabel>
          <StyledSelect
            labelId="tt-line"
            label={"Line"}
            onChange={handleLineChange}
            value={line}
          >
            <MenuItem value=""></MenuItem>
            {ttLineData.map((lineItem, index) => (
              <MenuItem key={index} value={lineItem.line_id}>
                {lineItem.line_id}
              </MenuItem>
            ))}
          </StyledSelect>
        </FormControl>
      )}
      {type === "stops" && (
        <FormControl style={{ width: "350px", zIndex: 2 }}>
          <StyledInputLabel htmlFor="tt-stop">Stop</StyledInputLabel>
          <StyledSelect
            labelId="tt-stop"
            label={"Stop"}
            onChange={handleStopChange}
            value={stop}
          >
            <MenuItem value=""></MenuItem>
            {ttStopData.map((stopItem, index) => (
              <MenuItem
                key={index}
                value={
                  stopItem.stop_id.toString().length === 4
                    ? "0" + stopItem.stop_id
                    : stopItem.stop_id
                }
              >
                {stopItem.stop_name}
              </MenuItem>
            ))}
          </StyledSelect>
        </FormControl>
      )}
    </>
  );
}

export default HistoricalDashboardForTTAndRTM;
